export default "__VITE_ASSET__CGDQdnpa__"